import { queryData } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getTestType = async (id) => {
  return await queryData(`${GlobalConfig.REACT_APP_API_NUTTYPE_URL}${id}`);
};
